import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PlatformOrgUploadSignalRPayload } from '../../core-data-model';

/**
 * Pass-through service to handle SignalR messages for PlatformOrgUpload
 * and update the BehaviorSubject for subscribers.
 */
@Injectable({
    providedIn: 'root'
})
export class PlatformOrgUploadMessageService {
    platformOrgUploadSignalRMessage$: Subject<PlatformOrgUploadSignalRPayload> =
        new Subject<PlatformOrgUploadSignalRPayload>();

    /**
     * Process the message from SignalR and update the BehaviorSubject
     *
     * @param payload
     */
    processMessage(payload: PlatformOrgUploadSignalRPayload) {
        this.platformOrgUploadSignalRMessage$?.next(payload);
    }
}
